const browserHost =
  typeof window !== "undefined" ? window.location.hostname : "";

const isLocalBrowser =
  browserHost === "localhost" ||
  browserHost === "127.0.0.1" ||
  browserHost === "0.0.0.0";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (isLocalBrowser
    ? "https://api.mandapai.in"
    : "https://api.mandapai.in");
// export const API_BASE_URL =
// "https://api.mandapai.in"

export const CLIENT_BASE_URL =
  process.env.REACT_APP_CLIENT_BASE_URL ||
  (isLocalBrowser ? "http://localhost:3000" : "https://mandapai.in");